export default {
  carregando: false,

  listaProvedores: [],   
  paginacaoProvedores: null,

  provedor: null,
  workflows: [],
  paginacaoWorkflows: null,
  
  filtroData: null,
};
